<template>

    <datepicker-range 
    :focusedInput="focusedInput" :onFocusChange="onFocusChange" :onDatesChange="onDatesChange"
        :block="block"
        :startDate="startDate" :startDateId="startDateId" :endDateId="endDateId" :numberOfMonths="numberOfMonths"
        :endDate="endDate" :appendToBody="appendToBody" :displayFormat="displayFormat" :isOutsideRange="isOutsideRange"
        :disableScroll="false" />
</template>

<script>
    import {
        ReactWrapper,
        ReactInVue
    } from './vuera'
    import './react-dates/initialize';

    import moment from 'moment'
    import {
        DateRangePicker,
        SingleDatePicker,
        DatePickerRangeController,
        isInclusivelyAfterDay
    } from './react-dates';

    export default {
        name: 'MAGDatepickerRange',
        components: {
            "datepicker-range": ReactInVue(DateRangePicker)
        },
        props: {
            block: {
                default: false,
                type: Boolean
            },
            dateFormat: {
                default: "DD/MM/YYYY",
                type: String
            },
            displayFormat: {
                default () {
                    return this._dateFormat
                },
                type: String
            },
            monthFormat: {
                default: "MMMM YY",
                type: String
            },
            initialStartDate: {
                default: () => {
                    return moment()
                },
            },
            initialEndDate: {
                default: () => {
                    return moment().add(1, 'days')
                },
            },
            minDate: {
                default: () => {
                    return moment()
                },
                type: Object
            },
            maxDate: {
                default: () => {
                    return moment().add(1, 'years')
                },
                type: Object
            },
            numberOfMonths: {
                default: 2,
                type: Number
            },
            selectableRanges: {
                default: () => [],
                type: Array
            },
            dateRangeFormat: {
                default () {
                    return this._dateFormat
                },
                type: String
            },
            appendToBody: {
                default: false,
                type: Boolean
            }
        },
        computed: {
            _dateFormat() {
                return this.dateFormat ? this.dateFormat : "DD/MM/YYY"
            }
        },
        data() {
            return {
                startDate: null,
                endDate: null,
                startDateId: "startDate",
                endDateId: "endDate",
                focusedInput: "startDate",
                isOutsideRange: () => false
            }
        },
        mounted() {
            this.initialStartDate ? this.startDate = this.initialStartDate : this.startDate = null;
            this.initialEndDate ? this.endDate = this.initialEndDate : this.endDate = null;
            if (this.selectableRanges.length > 0) this.isOutsideRange = (day) => {
                for (let selectedRangeIndex = 0; selectedRangeIndex < this.selectableRanges
                    .length; selectedRangeIndex++) {
                    var rangeStart = this.selectableRanges[selectedRangeIndex][0];
                    var rangeEnd = this.selectableRanges[selectedRangeIndex][1];
                    if (!isInclusivelyAfterDay(day, moment(rangeStart, this.dateRangeFormat)) ||
                        isInclusivelyAfterDay(day, moment(rangeEnd, this.dateRangeFormat))) continue
                    else return false;
                }
                return true;
            }
        },
        methods: {
            onDatesChange: function ({
                startDate,
                endDate
            }) {

                if (startDate) {
                    this.startDate = moment(startDate);
                    this.$emit("start-date-changed", moment(startDate));
                }
                if (endDate) {
                    this.endDate = moment(endDate);
                    this.$emit("end-date-changed", moment(endDate));
                }

                if (moment(this.endDate).isBefore(this.startDate)) this.endDate = null;
                //this.focusedInput === "startDate" ? this.focusedInput = "endDate" : this.onFocusChange(null);
            },
            onFocusChange: function (focusedInput) {
                //this.focusedInput = !focusedInput ? "startDate" : focusedInput
                this.focusedInput = focusedInput;
                this.$emit("input-field-toggled", focusedInput);
            }
        }
    }
</script>

<style lang="scss">
    @import '~react-dates/lib/css/_datepicker.css';

    .DayPicker__hidden {
        visibility: visible;
    }

    .DateRangePicker_picker {
        z-index: 2000;
    }
</style>